/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Loading } from "../../core";
import { useSelector, useDispatch } from "react-redux";

import { updateCurrentPath } from "../../redux/Action/pageRoot";
import { PrinterOutlined } from "@ant-design/icons";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./ComponentToPrint";
import { getInvoiceWithDispatchId } from "../../helper/utils/api/invoice";

const PrintInvoice = () => {
  const componentRef = useRef();
  let { id } = useParams();
  const dispatch = useDispatch();
  const [inVoiceData, setInVoiceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let userId = useSelector((state) => state.auth.userDetail._id);
  dispatch(updateCurrentPath("Invoice"));

  useEffect(() => {
    getInvoiceWithDispatchIdFromDb();
  }, [id]);

  const getInvoiceWithDispatchIdFromDb = async () => {
    setIsLoading(true);
    try {
      let {
        data: { result },
      } = await getInvoiceWithDispatchId(id);
      console.log("result[0]", result[0]);
      setInVoiceData(result);
    } catch (error) {
      console.log("error while geting active timecard", error);
    }
    setIsLoading(false);
  };

  console.log("inVoiceData", inVoiceData);

  return (
    <div>
      {isLoading && <Loading />}
      {inVoiceData && inVoiceData.length > 0 && (
        <>
          <ReactToPrint
            trigger={() => (
              <Button width="140px" margin="10px 10px 10px auto">
                <PrinterOutlined />
                Print this out!
              </Button>
            )}
            content={() => componentRef.current}
          />

          <ComponentToPrint
            ref={componentRef}
            userId={userId}
            inVoiceData={inVoiceData[0]}
          />
        </>
      )}
    </div>
  );
};

export default PrintInvoice;
